'use client';

import LauncherIntegrationUtils from 'epic-launcher-integration/app/scripts/utils/LauncherIntegrationUtils';
import 'epic-launcher-integration/app/styles/iframePayment.sass';
import {useEffect} from 'react';
// import 'epic-launcher-integration/app/styles/WebStyleOverrides.sass';

export const CheckoutInitializer = () => {
	useEffect(() => {
		LauncherIntegrationUtils.initPurchaseV2();
		LauncherIntegrationUtils.initWebIntegration();
	}, []);
	return null;
};
